import { computed, inject } from 'vue';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';
import { useLazyQueryWithCoordinator } from '@/services/graphql.utils';
import { useBuildPerformanceQuery } from '@/graphql/codegen/generated/graphql';
import { app } from '@/bootloader';
import { IKWorkloadBuildPerformanceData } from '../../workloads.injectionKeys';

export const useWorkloadViewPerformanceDataProvider = (buildId: string) => {
  const coordinatorService = inject(IKCoordinatorsService);
  const coordinatorId = coordinatorService?.selectedCoordinator.value;
  const GQL_useWorkloadPerformanceQuery = useLazyQueryWithCoordinator(
    useBuildPerformanceQuery,
    () => ({
      filter: {
        coordinatorId,
        buildId,
      },
    }),
    {
      fetchPolicy: 'no-cache',
    },
  );
  const performance = computed(() => GQL_useWorkloadPerformanceQuery.result.value?.buildDetails?.buildPerformance);
  const result = {
    GQL: GQL_useWorkloadPerformanceQuery,
    performance,
  };
  app.provide(IKWorkloadBuildPerformanceData, result);

  return result;
};

export const useWorkloadViewSummaryData = () => {
  const res = inject(IKWorkloadBuildPerformanceData);
  return res;
};
